import React, { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Capacitor } from '@capacitor/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { StatusBar, Style } from '@capacitor/status-bar';

import auth from '../services/auth'

const setNativeStatusBar = async () => {
  if (!Capacitor.isNativePlatform()) return;

  const platform = Capacitor.getPlatform();
  document.documentElement.classList.add(`native-${platform}`);
  document.body.classList.add(`native-${platform}`);

  await StatusBar.setStyle({ style: Style.Dark });

  if (platform === 'android') {
    await StatusBar.setOverlaysWebView({ overlay: true });
  }
};

function Layout(props){

	useEffect(() => {
    auth.setFirstVisit();
    setNativeStatusBar().catch(() => {});
		if (!Capacitor.isNativePlatform()){
			GoogleAuth.initialize();
		}
	}, []);

  return (
		<div>
			<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
				{props.children}
			</GoogleOAuthProvider>
		</div>
  );
};

export default Layout;
